export const site = {
  brand: "d.mar",
  brandSub: "Görüntüleme Merkezi",
  name: "d.mar Dental Görüntüleme Merkezi",
  tagline: "İstanbul'da dental radyoloji merkezi",
  domain: "https://dmar.com.tr/",
  address: "Halaskargazi Cad. Maya Apt. No:94 K:1 D:1, Osmanbey / Şişli, İstanbul",
  district: "İstanbul · Osmanbey / Şişli",
  email: "dmar.erguvan@gmail.com",
  phoneMain: "0 553 730 71 30",
  phoneMainHref: "tel:+905537307130",
  phoneLand: "0 212 343 30 30",
  phoneLandHref: "tel:+902123433030",
  whatsapp:
    "https://wa.me/905537307130?text=Merhaba%2C%20randevu%20almak%20istiyorum.",
  whatsappBase: "https://wa.me/905537307130?text=",
  directions:
    "https://www.google.com/maps/place/D.mar+Dental+G%C3%B6r%C3%BCnt%C3%BCleme+Merkezi/@41.0539658,28.9864392,17z",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.627699639873!2d28.98713469259033!3d41.05527001801697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab711fb81d4b9%3A0x990d979d20e78cd7!2sD.mar%20Dental%20G%C3%B6r%C3%BCnt%C3%BCleme%20Merkezi!5e0!3m2!1str!2str!4v1790352178135!5m2!1str!2str",
  hours: [
    { day: "Pazartesi – Cuma", value: "09:00 – 19:00" },
    { day: "Cumartesi", value: "09:00 – 17:00" },
    { day: "Pazar", value: "Kapalı (randevu ile)" },
  ],
};

export const navLinks = [
  { label: "Anasayfa", href: "/" },
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Hizmetler", href: "/hizmetler" },
  { label: "Diş Hekimleri", href: "/dis-hekimleri" },
  { label: "Hasta Bilgilendirme", href: "/hasta-bilgilendirme" },
  { label: "Neden d.mar", href: "/neden-dmar" },
  { label: "SSS", href: "/sss" },
  { label: "İletişim", href: "/iletisim" },
];

export const trustStats = [
  { value: "14+", label: "Yıllık tecrübe" },
  { value: "25.000+", label: "Yıllık çekim" },
  { value: "9", label: "Görüntüleme türü" },
  { value: "Aynı gün", label: "Dijital rapor" },
];

export const marqueeItems = [
  "Panoramik Röntgen",
  "Panoral 5 · MultiSlice",
  "Çocuk Panoramik",
  "Bite Wing",
  "Sefalometrik",
  "El-Bilek · Kemik Yaşı",
  "TME · Çene Eklemi",
  "3D Dental Tomografi (CBCT)",
  "TME (CBCT) · 3D",
  "DICOM · JPG · PNG · PDF",
];

export const audiences = [
  {
    badge: "Hastalar için",
    title: "Diş hekiminiz film istediyse",
    text: "Diş hekiminiz “panoramik çektir” ya da “3D tomografi gerekli” dediyse doğru yerdesiniz. İstediği filme göre randevunuzu WhatsApp'tan 60 saniyede oluşturalım.",
    points: [
      "Diş hekiminizin istediği filmi seçin",
      "WhatsApp'tan hızlı randevu",
      "Çekim yaklaşık 10-15 dakika sürer",
      "Görüntüler diş hekiminize dijital iletilir",
    ],
    cta: { label: "Hasta Bilgilendirme", href: "/hasta-bilgilendirme", tone: "primary" as const },
  },
  {
    badge: "Diş hekimleri için",
    title: "Kliniğiniz için görüntüleme partneri",
    text: "Hastalarınızı bize yönlendirin, aynı gün dijital raporu kliniğinize teslim edelim. Panoramik, CBCT ve sefalometrik dahil tüm çekimlerde hızlı, güvenilir radyoloji ortağınız.",
    points: [
      "Aynı gün dijital rapor teslimi",
      "DICOM / JPG / PNG / PDF formatları",
      "Online erişim, doğrudan iletişim hattı",
      "Düşük doz, modern cihaz altyapısı",
    ],
    cta: { label: "Diş Hekimleri İçin", href: "/dis-hekimleri", tone: "secondary" as const },
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Diş hekiminiz yönlendirir",
    text: "Hekiminizin istediği film türünü (panoramik, 3D tomografi, sefalometrik vb.) bize iletin.",
  },
  {
    step: "02",
    title: "Randevunuzu alın",
    text: "Telefon veya WhatsApp ile uygun saati seçin. Aynı gün için genellikle yer bulunur.",
  },
  {
    step: "03",
    title: "Çekiminiz yapılır",
    text: "Merkezimize gelin; hazırlık, çekim ve teslim yaklaşık 10-15 dakika sürer. Dijital ve düşük doz.",
  },
  {
    step: "04",
    title: "Sonuç hekiminize ulaşır",
    text: "Görüntü ve rapor aynı gün diş hekiminize dijital olarak iletilir; tedavi planlaması başlar.",
  },
];

export const reasons = [
  {
    icon: "ri-time-line",
    title: "Aynı gün rapor",
    text: "Çekim biter bitmez görüntüler ve rapor hazırlanır; diş hekiminize aynı gün iletilir.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Düşük doz dijital",
    text: "Modern dijital panoramik ve CBCT cihazları, düşük radyasyon dozuyla yüksek görüntü kalitesi sunar.",
  },
  {
    icon: "ri-whatsapp-line",
    title: "WhatsApp ile hızlı iletişim",
    text: "Randevu, soru ve sonuç — hepsi WhatsApp'tan. Yazışma kaydı sizde kalır.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Osmanbey'in merkezinde",
    text: "Halaskargazi Caddesi üzerinde; metro ve otobüsle kolay ulaşım, yakın otopark imkânı.",
  },
  {
    icon: "ri-award-line",
    title: "Diş hekimi onaylı",
    text: "Yıllardır yüzlerce diş hekiminin güvendiği radyoloji partneri. Doğru tanı, doğru planlama.",
  },
  {
    icon: "ri-stack-line",
    title: "14+ yıllık tecrübe",
    text: "Dental radyolojiye odaklanmış deneyimli teknik kadro ve uzman konsültasyonu.",
  },
];